/**
 *
 * @param {Ref} element a ref of the element to scroll to the top off
 */
const scrollToTop = (element) => {
  element.current.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

/**
 *
 * @param {number} days the number days to calculate for after today (including today)
 * @returns an array with key display in the form (Mar 30, Monday) and iso date of as value
 */
const getDatesFromToday = (days = 5, weekday = 'long') => {
  const dates = [];
  for (let i = 0; i < days; i++) {
    dates.push({
      display: new Date(new Date().setDate(new Date().getDate() + i))
        .toLocaleDateString('en', {
          month: 'short',
          weekday,
          day: 'numeric',
        })
        .replace(',', '')
        .split(' '),
      value: new Date().setDate(new Date().getDate() + i),
    });
  }

  return dates;
};

/**
 *
 * @param {number} percentage the percentage to convert to a color
 * @returns the corresponding color for the percentage
 */
const returnColor = (percentage) => (percentage >= 0.75 ? '#1bc47d' : percentage >= 0.25 ? '#ffdd7a' : '#eb4335');

/**
 *
 * @returns a random color and lighter version of it
 */
const randomColorAndLighter = () => {
  const color = `#${(Math.random() * 0xfffff * 1000000).toString(16).slice(0, 6)}`;
  const lighter = `${color}99`;
  return { color, lighter };
};

/**
 *
 * @param {*} status
 * @returns
 */
const getCallStatus = (status) => {
  switch (status) {
    case 'NA':
      return 'Did Not Answer';
    case 'NI':
      return 'Not Interested';
    case 'CB':
      return 'Call Back';
    case 'DC':
      return 'Do Not Call Back';
    case 'SZ':
      return 'Scheduled Virtual Appointment';
    case 'CC':
      return 'Call Completed';
    default:
      return '';
  }
};

/**
 *
 * @param {datestring} date the date to convert to a string
 * @returns  date Thursday, Jun 02, 2022, 02:05 PM
 */
const getFormattedDate = (date) =>
  new Date(date).toLocaleString('en', {
    weekday: 'long',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const getShortDate = (date) => {
  if (!date) {
    return 'NA NA NA';
  }
  const day = new Date(date).toLocaleString('en', { weekday: 'long' });
  const month = new Date(date).toLocaleString('en', { month: 'short' });
  const num = new Date(date).toLocaleString('en', { day: 'numeric' });

  return `${day.slice(0, 3)} ${month} ${num}`;
};

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    // var intlCode = match[1] ? '+1 ' : '';
    return ['(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null || phoneNumberString;
}

/**
 *
 * @param {*} number number to format
 * @param {*} decimals number of decimals to show, default 2
 * @returns formatted number
 */
const formatNumber = (number, decimals = 2) =>
  Number(number).toLocaleString('en-US', { minimumFractionDigits: decimals });

/**
 *
 * @param {Date} date date to convert to UTC
 * @returns  eg.'Tue, 13 Dec 2022 11:35'
 */
const getUTC = (date) => {
  const dateObj = new Date(date);
  const [first, second] = dateObj.toUTCString().split(':');
  return `${first}:${second}`;
};

export {
  scrollToTop,
  getDatesFromToday,
  returnColor,
  randomColorAndLighter,
  getCallStatus,
  getFormattedDate,
  capitalizeFirstLetter,
  getShortDate,
  formatNumber,
  formatPhoneNumber,
  getUTC,
};
